const focusableSelector = [
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'a[href]',
  '[tabindex]:not([tabindex="-1"])'
].join(',');

function getActiveModal(): HTMLElement | null {
  const modals = Array.from(document.querySelectorAll<HTMLElement>('.modal'));
  return modals.length ? modals[modals.length - 1] : null;
}

function getFocusable(modal: HTMLElement): HTMLElement[] {
  return Array.from(modal.querySelectorAll<HTMLElement>(focusableSelector))
    .filter((el) => !el.hasAttribute('disabled'));
}

function focusFirst(modal: HTMLElement) {
  const focusable = getFocusable(modal);
  const first = focusable[0] || modal;
  if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');
  setTimeout(() => first.focus(), 0);
}

function isInsideModal(target: EventTarget | null, modal: HTMLElement) {
  return Boolean(target instanceof Node && modal.contains(target));
}

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab') return;

  const modal = getActiveModal();
  if (!modal) return;

  const focusable = getFocusable(modal);
  if (!focusable.length) {
    event.preventDefault();
    modal.focus();
    return;
  }

  if (!isInsideModal(document.activeElement, modal)) {
    event.preventDefault();
    focusable[0].focus();
    return;
  }

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}, true);

const observer = new MutationObserver(() => {
  const modal = getActiveModal();
  if (!modal) return;

  if (modal.dataset.sptFocusReady === 'yes') return;
  modal.dataset.sptFocusReady = 'yes';
  focusFirst(modal);
});

observer.observe(document.documentElement, { childList: true, subtree: true });

export {};
